export type SearchResultPathSegment = {
  name: string;
};

export function formatSearchResultPath(
  path: readonly SearchResultPathSegment[] | null | undefined,
): string {
  return (path ?? [])
    .map((segment) => segment.name.trim())
    .filter((name) => name.length > 0)
    .join('/');
}

export function formatContainerSearchResultParentPath(
  path: readonly SearchResultPathSegment[] | null | undefined,
  rootLabel: string,
): string {
  const names = (path ?? [])
    .map((segment) => segment.name.trim())
    .filter((name) => name.length > 0);

  if (names.length === 0) {
    return '';
  }

  if (names.length === 1) {
    return rootLabel.trim();
  }

  return names.slice(0, -1).join('/');
}
